$(document).ready(function(){
    var anchorSections = [];
    var anchorSectionLinks = [];

    $(".anchor-sections .anchor-section").map(function(i, e){
        anchorSections.push($(e));
        $(this).attr("data-index", i);
    });

    $(".anchor-navigation a").map(function(i, e){
        anchorSectionLinks.push($(e));
        $(this).attr("data-index", i);
    });

    /*$(".anchor-navigation a").on("click", function(e){
        e.preventDefault();
        var index = $(this).data("index");
        $("html, body").animate({scrollTop: $(anchorSections[index]).offset().top}, 500);
    });*/

    function hashTabs(){
        var hash = window.location.hash.substr(1);

        if(hash != ""){
            $("html, body").animate({scrollTop: $(anchorSections[hash]).offset().top}, 500);
        }
    }

    setTimeout(hashTabs);

    $(".main-navigation .dropdown li").on("click", function(){
        setTimeout(hashTabs);
    });

    $(".mobile-dropdown ul li").on("click", function(){
        setTimeout(hashTabs);
    });

    $(".footer-navigation-main p a").on("click", function(){
        setTimeout(hashTabs);
    });

    $(".footer-accordion p a").on("click", function(){
        setTimeout(hashTabs);
    });
});


// WEBPACK FOOTER //
// src/js/bundle/other-services.js